import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { IAuthResponse, User, UserRoles, initialUser } from '../../Interfaces';
import { addOrUpdateUser, deleteUser, getUser, resetPassword } from '../../Data/ApiUserRequests';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';



const UserManagerCard: React.FC = () => {
 const navigate = useNavigate();
 const bearerToken: IAuthResponse = useSelector((state: IAuthResponse) => state)
 const { uid } = useParams();
 const [isAddUpdateOpenDialog, setAddUpdateOpenDialog] = useState(false)
 const [isRemoveOpenDialog, setIsRemoveOpenDialog] = useState(false)
 const [isResetPasswordDialog, setIsResetPasswordDialog] = useState(false)
 const [operationResult, setOperationResult] = useState('')
 const [operationRemoveResult, setOperationRemoveResult] = useState('')
 const [resetPasswordText, setResetPasswordText] = useState('')
 const [resetPasswordSuccessfully, setResetPasswordSuccessfully] = useState(false)
 const [errorText, setErrorText] = useState('');
 const [showPassword, setShowPassword] = useState(false);
 const [password, setPassword] = useState('');
 const [confirmPassword, setConfirmPassword] = useState('');
 const [errorPasswordMessage, setErrorPasswordMessage] = useState('');
 const [currentUser, setCurrentUser] = useState<User>(initialUser);


 const resetOperationResults = ():void => {
  setOperationResult('');
  setOperationRemoveResult('');
  setResetPasswordText('');
  setErrorText('');

 }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCurrentUser({ ...currentUser, [name]: value });
  };

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    console.log(event)
    const { name, value } = event.target;
    setCurrentUser({ ...currentUser, [name]: value });
  };


    const updateUserInfo = async ():Promise<void> => {
        setAddUpdateOpenDialog(true);
        if (!currentUser.fullName || !currentUser.email) {
          setErrorText('Nicht alle erforderlichen Felder ausgefüllt')
          return;
        }
        await addOrUpdateUser(currentUser, bearerToken.token).then(response => {
          setOperationResult(response)
        }).catch(error => {
          setErrorText(error)
        });
    };



  const loadUsers = async() => {
    getUser(uid, bearerToken.token)
    .then(response => {
        if(process.env.NODE_ENV === 'development') console.log('users', response)
        const us:User = response
        setCurrentUser( us )
        return
    }).catch( () => {
        console.log('Error on load the data')
    })
  }
  useEffect( () => {
    loadUsers()
  }, [])


  const preDeleteUser = async () => {
    setIsRemoveOpenDialog(true);
    setOperationRemoveResult(`Möchten Sie  ${currentUser.fullName} wirklich löschen?`)

  }


  const confirmDeleteUser = async (userId: string | undefined) => {
    if(userId === undefined) return;
    deleteUser(userId , bearerToken.token)
      .then( response => {
        console.log(response)
        setOperationRemoveResult('Benutzer erfolgreich entfernt')
        setTimeout(() => {
          setIsRemoveOpenDialog(false)
          navigate(`/usermanager`)
        }, 3000)
    }).catch( error => {
      setOperationRemoveResult('Fehler beim Entfernen eines Benutzers.' + error)
      setIsRemoveOpenDialog(true);
  })
}


  const validatePassword = () => {
    // Password length check
    if (password.length < 8) {
      setErrorPasswordMessage('Das Passwort muss mindestens 8 Zeichen lang sein.');
      return false;
    }

    // Regex pattern to check for password requirements
    const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
    // Password pattern check
    if (!pattern.test(password)) {
      setErrorPasswordMessage('Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 digit, and 1 special character.');
      return false;
    }

    // Password match check
    if (password !== confirmPassword) {
      setErrorPasswordMessage('Passwords do not match');
      return false;
    }

    // Passwords meet all criteria
    setErrorPasswordMessage('');
    return true;
  }

  const confirmResetPassword = async () => {
    setResetPasswordText(`Neues Passwort für den Benutzer ${currentUser.fullName} festlegen?`)
    setIsResetPasswordDialog(true)
  }

  const ResetPassword = async (userId: string | undefined) => {
    console.log('userId', userId, {password}, bearerToken.token)
    resetPassword(userId, password, bearerToken.token).then(response => {
       setResetPasswordText(response)
       setResetPasswordSuccessfully(true)
       resetOperationResults()
    }).catch(error => {
      setResetPasswordText(error)
    })

  }

  return (
    <div>
      <h2>Nutzer bearbeiten</h2>
      <Grid container spacing={3} >
        <Grid item xs={3} sm={2} md={2} lg={2} xl={2} sx={{pl: 1, ml: 2}}>Name</Grid>
        <Grid item xs={8} sm={9} md={9} lg={9} xl={9}>
          <TextField
            type="text" placeholder="Name" label="Name"
            name="fullName"
          value={currentUser.fullName}
          onChange={handleInputChange}
          size='small' sx={{ width: '250px' }}
          InputLabelProps={{
            shrink: true,
        }}
        />   </Grid>

      <Grid item xs={3} sm={2} md={2} lg={2} xl={2} sx={{pl: 1, ml: 2}}>Email</Grid>
      <Grid item xs={8} sm={9} md={9} lg={9} xl={9}>
          <TextField
          label='Email' type="email"
          placeholder="Email" name="email"
          value={currentUser.email}
          onChange={handleInputChange}
          size='small' sx={{ width: '250px' }}
          InputLabelProps={{
            shrink: true,
        }}
        />  </Grid>

      <Grid item xs={3} sm={2} md={2} lg={2} xl={2} sx={{pl: 1, ml: 2}}>Nutzername</Grid>
      <Grid item xs={8} sm={9} md={9} lg={9} xl={9}>
          <TextField
          type="text" label='Nutzername'
          placeholder="Nutzername"
          name="userName"
          value={currentUser.userName}
          onChange={handleInputChange}
          size='small' sx={{ width: '250px' }}
          InputLabelProps={{
            shrink: true,
        }}
        />
          </Grid>
          <Grid item xs={3} sm={2} md={2} lg={2} xl={2} sx={{pl: 1, ml: 2}}>Rolle</Grid>
          <Grid item xs={8} sm={9} md={9} lg={9} xl={9} >
            <Select
              type="text"
              label='Gruppe'
              placeholder="Gruppe"
              name="role"
              size='small' sx={{ width: '250px' }}
              value={currentUser.role?.toString()} onChange={ handleSelectChange }>
                      {
                        UserRoles.map(u=> {
                          return(
                            <MenuItem key={`user`} value={u.roleValue} selected={(currentUser.roleString === u.roleTitle) ? true : false}>{u.roleTitle}</MenuItem>
                          )
                        })
                      }</Select>

                {/* <MenuItem key={`admin`} value={0} selected={currentUser.role === 0}>Admin</MenuItem>
                <MenuItem key={`user`} value={1} selected={currentUser.role === 1}>User</MenuItem> */}
        </Grid>

        <Grid item xs={3} sm={2} md={2} lg={2} xl={2} sx={{pl: 1, ml: 2}}></Grid>
        <Grid item xs={8} sm={9} md={9} lg={9} xl={9}>
            <Button variant='contained' color='primary' onClick={updateUserInfo}>Benutzer aktualisieren</Button>
        </Grid>


        <Grid item xs={3} sm={2} md={2} lg={2} xl={2} sx={{pl: 1, ml: 2}}></Grid>
        <Grid item xs={8} sm={9} md={9} lg={9} xl={9}>
          <Button onClick={() => { confirmResetPassword() }}  color='secondary' variant='contained'>Passwort zurücksetzen</Button>
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={2} xl={2} sx={{pl: 1, ml: 2}}></Grid>
        <Grid item xs={8} sm={9} md={9} lg={9} xl={9}>
          <Button onClick={() => { navigate('/usermanager/') }}  color='secondary' variant='contained'>Schliessen</Button>
        </Grid>

        <Grid item xs={12} sm={10} md={8} lg={8} xl={8} sx={{pl: 1, ml: 2}} >
        <Button variant='contained' color='warning' onClick={() => {
                if(currentUser.id !== undefined) preDeleteUser()
            }
            }>Löschen</Button>
                </Grid>
            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} sx={{pl: 1, ml: 2}}> </Grid>
            </Grid>
      <ul>

      </ul>

        <Dialog open={isAddUpdateOpenDialog}>
            <DialogTitle></DialogTitle>
            <DialogContent>
            <Alert severity={errorText !== '' ? 'error' : 'success' } >
                {errorText !== '' ?  errorText : operationResult  }
            </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                  setAddUpdateOpenDialog(false);
                  setOperationResult('');
                  setErrorText('');
                  navigate('/usermanager/')
                  }}>Schliessen</Button>
            </DialogActions>
        </Dialog>



      <Dialog open={isRemoveOpenDialog}>
        <DialogTitle></DialogTitle>
        <DialogContent>
          <Alert severity={errorText !== '' ? 'error' : 'success'} >
            {errorText !== '' ? errorText : operationRemoveResult}
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setIsRemoveOpenDialog(false);
            resetOperationResults();
          }}
            color="primary">
            { operationRemoveResult !== 'Benutzer erfolgreich entfernt' ? 'Abbrechen' : 'Schliessen'
}
          </Button>
          {
          operationRemoveResult !== 'Benutzer erfolgreich entfernt' &&
            <Button onClick={() => confirmDeleteUser(currentUser.id)} color="secondary">
              Löschen
            </Button>
      }

        </DialogActions>
      </Dialog>

        <Dialog open={isResetPasswordDialog}>
            <DialogTitle>Passwort zurücksetzen</DialogTitle>
            <DialogContent>
              { resetPasswordText }
              {
                !resetPasswordSuccessfully &&
                <>
                <Box sx={{p: 1}}>
                <TextField name='newPassword' label='Password' size='small'
                     value={password}
                     sx={{ width: '250px' }}
                     type={showPassword ? "text" : "password"} // <-- This is where the magic happens
                     onChange={(e) => setPassword(e.target.value)}
                     InputProps={{ // <-- This is where the toggle button is added.
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)} size='small'
                            onMouseDown={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                />
                </Box><Box sx={{p: 1}}>
                <TextField name='conFormNewPassword' label='Confirm Password' size='small'
                    type="password" sx={{ width: '250px' }}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                </Box>
                </>
              }
            {errorPasswordMessage && <p style={{ color: 'red' }}>{errorPasswordMessage}</p>}
              </DialogContent>
              <DialogActions>
              <Button onClick={ ()=> {
                setIsResetPasswordDialog(false)
                setResetPasswordSuccessfully(false)
                setPassword('')
                setConfirmPassword('')

              } }
              color="primary">Abbrechen</Button>
              { !resetPasswordSuccessfully &&
              <Button onClick={() => {

                if( validatePassword()) {
                  ResetPassword(currentUser.userName)}
                }
              }
                color="secondary">Passwort zurücksetzen</Button>

               }
            </DialogActions>
              </Dialog>

    </div>
  );
};

export default UserManagerCard;
